var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown-divider',{class:_vm.lodash.get(_vm.cp, 'props.tag'),style:(_vm.lodash.get(_vm.cp, 'props.tag')),attrs:{"tag":_vm.lodash.get(_vm.cp, 'props.tag', 'hr')}})}
var staticRenderFns = []

export { render, staticRenderFns }